import React, { useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const NavigateBack = ({ label = "Back", className = "", target = null, targetBack = null, containerClassName = "" }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (target) {
            navigate(target); // Navigate to the specified target
        } else if (targetBack){
            navigate(-1); // Navigate to the previous page
        }
    };

    useEffect(() => {
        // Scroll to the top of the page when the component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={`flex justify-between items-center py-[1.15rem] bg-gradient-to-r from-indigo-200 to-blue-100 ${containerClassName}`}>
            <div className={`flex items-center cursor-pointer hover:-translate-x-1 duration-300 ${className}`} onClick={handleBack}>
                <IoIosArrowBack 
                className="cursor-pointer h-6 w-6 z-10 mr-1 text-gray-800 transition-transform transform" />
                <h1 className="text-xl font-semibold">{label}</h1>
            </div>
            <div></div>
        </div>
    );
};

export default NavigateBack;
